<!-- SPREADSHEET VIEW -->
<div class="spreadsheet-container">
<nb-card class="spreadsheet-card-wrapper">
  <nb-card-body class="spreadsheet p-0" (outsideClick)="clearSelection()" appOutsideClick>
    <!-- SUMMARY AND FILTERS -->
    @if (!selectedRowsNb || selectedRowsNb === 1) {
    <div class="row header-container">
      <!-- SUMMARY -->
      <div class="col-lg-9 spreadsheet-card__investment-total">
        <ng-container>
          {{
            "pages.decision.spreadsheet.total_investment_budget"
              | translate
                : {
                    totalInvestmentBudget: filteredInvestAmount,
                    filteredInvestNb: filteredInvestNb
                  }
          }}
        </ng-container>
      </div>
      <!-- FILTERS -->
      <div class="col-lg-3 px-0">
        <app-table-filter [filtersNb]="filtersNb" tableType="invest"></app-table-filter>
      </div>
    </div>
    }

    <!-- SELECTED ROWS / TOTAL ROWS -->
    @if (selectedRowsNb > 1) {
    <div class="row header-container">
      <div class="selected-rows">
        <span
          [innerHTML]="
            '{selectedRowsNb} out of {loadedRowsNb} selected'
              | translate : { selectedRowsNb: selectedRowsNb, loadedRowsNb: loadedRowsNb }
          "
        ></span>
        @if (filteredInvestNb > cacheBlockSize && filteredInvestNb !== loadedRowsNb && loadedRowsNb === selectedRowsNb)
        {
        <span
          [innerHTML]="'Please note, there is a total of {total} investments' | translate : { total: filteredInvestNb }"
          class="missing-rows"
        ></span>
        }
        <span class="right">
          @if (filtersNb > 0) {
            <span class="filtersNb">
              {{ "pages.decision.spreadsheet.header.filters_nb" | translate : { filtersNb: filtersNb } }}
            </span>
          }
          <a (click)="clearSelection()">{{ "Clear selection" | translate }}</a>
        </span>
      </div>
    </div>
    }

    <div style="height: calc(100% - 60px)" #grid>
      <ag-grid-angular
        #agGrid
        class="ag-theme-balham ag-grid-kpi"
        [gridOptions]="gridOptions"
        (filterChanged)="onFilterChanged()"
        (gridReady)="onGridReady($event)"
      ></ag-grid-angular>
    </div>
  </nb-card-body>
</nb-card>

@if (showAddButton) {
<button class="investment-add-btn" (click)="showInvestmentWizard()"> <i class="fa-thin fa-plus fa-2x"></i></button>
}
</div>
